<template>
<div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12 md11>
                <app-card pt-0>
                    <v-card-title>
                        <h4>BÁO CÁO NHANH NHẬN PHÒNG</h4>
                        <v-spacer></v-spacer>
                        <v-layout row justify-end>
                            <v-flex xs12>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="rowPerPage"
                    >
                        <template #headers="props">
                            <tr>
                                <th class="text-xs-center fw-bold" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <td class="text-center">{{ props.item.agent }}</td>
                            <td class="text-center">{{ props.item.receipt_id }}</td>
                            <td class="text-center text-no-wrap">{{ props.item.dateCreate }}</td>
                            <td class="text-center">{{ props.item.room_id }}</td>
                            <td class="text-center">{{ props.item.building_id }}</td>
                            <td class="text-center text-no-wrap">{{ props.item.name }}</td>
                            <td class="text-center">{{ props.item.phone }}</td>
                            <td class="text-center">{{ props.item.roomPrice }}</td>
                            <td class="text-center">{{ props.item.depositAmount }}</td>
                            <td class="text-center text-no-wrap">{{ props.item.dateIn }}</td>
                            <td class="text-center text-no-wrap">{{ props.item.dateInReal }}</td>
                            <td class="text-center">{{ props.item.note }}</td>
                            <td class="text-center">{{ props.item.internet_price }}</td>
                            <td class="text-center">{{ props.item.electric_count_1 }}</td>
                            <td class="text-center">{{ props.item.electric_count_2 }}</td>
                            <td class="text-center">{{ props.item.water_count_1 }}</td>
                            <td class="text-center">{{ props.item.water_count_2 }}</td>
                            <td class="text-center">{{ props.item.electric_diff }}</td>
                            <td class="text-center">{{ props.item.water_diff }}</td>
                            <td class="text-center">{{ props.item.is_contracted }}</td>
                            <td class="text-center">{{ props.item.information_id }}</td>
                            <td class="text-center">{{ props.item.is_temp }}</td>
                        </template>
                    </v-data-table>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import api from "Api";

export default {
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "Người dẫn", align: "center", value: "agent" },
                { text: "Chứng từ đặt", align: "center", value: "receipt_id" },
                { text: "Ngày tạo", align: "center", value: "dateCreate" },
                { text: "Số phòng", align: "center", value: "room_id" },
                { text: "Tòa nhà", align: "center", value: "building_id" },
                { text: "Họ tên", align: "center", value: "name" },
                { text: "SDT", align: "center", value: "phone" },
                { text: "Giá Phòng", align: "center", value: "roomPrice" },
                { text: "Tiền cọc", align: "center", value: "depositAmount" },
                { text: "Ngày vào", align: "center", value: "dateIn" },
                { text: "Ngày vào thực tế", align: "center", value: "dateInReal" },
                { text: "Ghi chú", align: "center", value: "note" },
                { text: "Sử dụng mạng", align: "center", value: "internet_price" },
                { text: "Số điện 1", align: "center", value: "electric_count_1" },
                { text: "Số điện 2", align: "center", value: "electric_count_2" },
                { text: "Số nước 1", align: "center", value: "water_count_1" },
                { text: "Số nước 2", align: "center", value: "water_count_2" },
                { text: "Chênh lệch điện", align: "center", value: "electric_diff" },
                { text: "Chênh lệch nước", align: "center", value: "water_diff" },
                { text: "Hợp đồng", align: "center", value: "is_contracted" },
                { text: "Phiếu thông tin", align: "center", value: "information_id" },
                { text: "Tạm trú", align: "center", value: "is_temp" },
            ],
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}]
        };
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData() {
            let dummy_data = [
                {
                    agent: 'Thảo',
                    receipt_id: '105-TT',
                    dateCreate: '3/6/2018',
                    room_id: '519GB',
                    building_id: 'GB',
                    roomPrice: '5,000,000',
                    depositAmount: '5,000,000',
                    name: 'Nguyễn Thị Thoại Thương',
                    phone: '0902874321',
                    dateIn: '31/03/2019',
                    dateInReal: '31/03/2019',
                    note: '',
                    internet_price: '209,000',
                    electric_count_1: '749',
                    electric_count_2: '749',
                    water_count_1: '81',
                    water_count_2: '81',
                    electric_diff: '0',
                    water_diff: '0',
                    is_contracted: 'có',
                    information_id: '19-DC',
                    is_temp: '',
                },
            ]
            for (let index = 0; index < 7; index++) {
                const element = dummy_data[0];
                this.items.push(element)
            }
        }
    }
};
</script>
